import React from 'react';
import { Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';

import styles from './styles';
const useStyles = makeStyles(styles);

const MoreMenu = () => {
  const classes = useStyles();
  const locale = localStorage.getItem('lang');
  return (
    <>
      <div className={classNames(classes.topheader)}>{keyEmptyCheck('more')}</div>
      <div className={classNames(classes.LinkMain)}>
        <Link href={`/${localStorage.getItem('lang')}/app/directory`} className={classNames(classes.sidebarListItem)}>
          <ADGMImage name='Directory_mob.svg' />
          <Typography component='h3' className={classes.subTitlethree}>
            {keyEmptyCheck('Directory')}
          </Typography>
        </Link>
        <Link href={`/${localStorage.getItem('lang')}/app/contracts`} className={classNames(classes.sidebarListItem)}>
          <ADGMImage name='contracts_mob.svg' />
          <Typography component='h3' className={classes.subTitlethree}>
            {keyEmptyCheck('CONTRACT')}
          </Typography>
        </Link>
      </div>
    </>
  );
};

export default MoreMenu;
